<div [class]="containerClass()" aria-hidden="true">
  <svg
    [style]="iconStyle()"
    [class]="svgClass()"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
  >
    <g>
      @if (direction() === 'down') {
        @if (double()) {
          <path
            d="M12,17.25a.74.74,0,0,1-.53-.22L8,13.53A.75.75,0,0,1,9,12.47l3,3,3-3A.75.75,0,0,1,16,13.53L12.53,17A.74.74,0,0,1,12,17.25Z"
          />
          <path
            d="M12,11.75a.74.74,0,0,1-.53-.22L8,8A.75.75,0,0,1,9,7l3,3,3-3A.75.75,0,0,1,16,8l-3.5,3.5A.74.74,0,0,1,12,11.75Z"
          />
        } @else {
          <path
            d="M12,15.25a.74.74,0,0,1-.53-.22l-5-5A.75.75,0,0,1,7.53,9L12,13.44,16.47,9A.75.75,0,0,1,17.53,10l-5,5A.74.74,0,0,1,12,15.25Z"
          />
        }
      }
      @if (direction() === 'up') {
        @if (double()) {
          <path
            d="M15.5,11.75a.74.74,0,0,1-.53-.22l-3-3-3,3A.75.75,0,0,1,8,10.47L11.47,7a.75.75,0,0,1,1.06,0l3.5,3.5a.75.75,0,0,1,0,1.06A.74.74,0,0,1,15.5,11.75Z"
          />
          <path
            d="M15.5,17.25A.74.74,0,0,1,15,17l-3-3L9,17A.75.75,0,0,1,8,16l3.5-3.5a.75.75,0,0,1,1.06,0L16,16A.75.75,0,0,1,16,17,.74.74,0,0,1,15.5,17.25Z"
          />
        } @else {
          <path
            d="M17,15.25a.74.74,0,0,1-.53-.22L12,10.56,7.53,15A.75.75,0,0,1,6.47,14l5-5a.75.75,0,0,1,1.06,0l5,5a.75.75,0,0,1,0,1.06A.74.74,0,0,1,17,15.25Z"
          />
        }
      }
      @if (direction() === 'left') {
        @if (double()) {
          <path
            d="M11,16.25a.74.74,0,0,1-.53-.22L7,12.53a.75.75,0,0,1,0-1.06L10.47,8A.75.75,0,0,1,11.53,9l-3,3,3,3a.75.75,0,0,1,0,1.06A.74.74,0,0,1,11,16.25Z"
          />
          <path
            d="M16.5,16.25A.74.74,0,0,1,16,16l-3.5-3.5a.75.75,0,0,1,0-1.06L16,8A.75.75,0,0,1,17,9l-3,3,3,3A.75.75,0,0,1,17,16,.74.74,0,0,1,16.5,16.25Z"
          />
        } @else {
          <path
            d="M14,17.75a.74.74,0,0,1-.53-.22l-5-5a.75.75,0,0,1,0-1.06l5-5a.75.75,0,0,1,1.06,1.06L10.06,12l4.47,4.47a.75.75,0,0,1,0,1.06A.74.74,0,0,1,14,17.75Z"
          />
        }
      }
      @if (direction() === 'right') {
        @if (double()) {
          <path
            d="M13,16.25a.74.74,0,0,1-.53-.22.75.75,0,0,1,0-1.06l3-3-3-3A.75.75,0,0,1,13.53,8l3.5,3.5a.75.75,0,0,1,0,1.06L13.53,16A.74.74,0,0,1,13,16.25Z"
          />
          <path
            d="M7.5,16.25A.74.74,0,0,1,7,16,.75.75,0,0,1,7,15l3-3L7,9A.75.75,0,0,1,8,8l3.5,3.5a.75.75,0,0,1,0,1.06L8,16A.74.74,0,0,1,7.5,16.25Z"
          />
        } @else {
          <path
            d="M10,17.75a.74.74,0,0,1-.53-.22.75.75,0,0,1,0-1.06L13.94,12,9.47,7.53a.75.75,0,0,1,1.06-1.06l5,5a.75.75,0,0,1,0,1.06l-5,5A.74.74,0,0,1,10,17.75Z"
          />
        }
      }
    </g>
  </svg>
</div>
